module.exports = {"formats":{"date":"DD/MM/YYYY","hour":"HH:mm"},"occupancy":{"title":"SYNTHÈSE D'OCCUPATION","desks":"Bureaux","floors":"Étages","meetingRooms":"Salles de réunion","restaurant":{"title":"Rise Café","attendance1":"< 5 mn","attendance2":"de 5 à 10 mn","attendance3":"> 10 mn"}}}


//////////////////
// WEBPACK FOOTER
// ./src/store/i18n/locales/fr.json
// module id = 123
// module chunks = 0